import React, { useEffect } from "react";
import styled from "styled-components";
import ContactForm from "./ContactForm";
import AOS from "aos";
import { FaLocationDot } from "react-icons/fa6";
import { FaEnvelope } from "react-icons/fa6";
import { FaPhoneAlt } from "react-icons/fa";

function ContactBody() {
  useEffect(() => {
    AOS.init({
      duration: 1200,
    });
  }, []);

  return (
    <Container>
      <Wrap>
        <Left data-aos="fade-right">
          <div>
            <h2>Our Address</h2>
            <Box>
              <FaLocationDot className="icon_contact" />
              <p>
              No: 468, 4th Floor, Jana Jaya City Mall (JJC MALL), Rajagiriya, Sri Lanka. 
              </p>
            </Box>
          </div>

          <div>
            <h2>E-mail</h2>
            <Box>
              <FaEnvelope className="icon_contact" />
              <p>info@ibexfilmz.com</p>
            </Box>
            <Box>
              <FaEnvelope className="icon_contact" />
              <p>ibexfilmz@gmail.com </p>
            </Box>
          </div>

          <div>
            <h2>Phone Numbers</h2>
            <Box>
              <FaPhoneAlt className="icon_contact" />
              <p>+971556959040</p>
            </Box>
            <Box>
              <FaPhoneAlt className="icon_contact" />
              <p>+971556959040</p>
            </Box>
            
          </div>
        </Left>
        <Right data-aos="fade-left">
          <ContactForm />
        </Right>
      </Wrap>
    </Container>
  );
}

const Container = styled.div`
  width: 100%;
  min-height: 80vh;
  background: var(--primary-color);
  color: #fff;
  display: flex;
  justify-content: center;
`;

const Wrap = styled.div`
  width: 75%;
  display: flex;

  @media only screen and (max-width: 1024px) {
    width: 90%;
    flex-direction: column;
    align-items: center;
    text-align: center;
  }

  @media only screen and (max-width: 768px) {
    width: 95%;
  }
`;

const Left = styled.div`
  width: 50%;
  display: flex;
  align-items: center;
  flex-direction: column;
  padding: 50px;

  @media only screen and (max-width: 1024px) {
    width: 100%;
    padding: 30px;
  }

  @media only screen and (max-width: 768px) {
    padding: 20px;
  }

  div {
    width: 100%;
    margin: 10px 0;
  }

  h2 {
    font-size: 30px;

    @media only screen and (max-width: 1024px) {
      font-size: 26px;
    }

    @media only screen and (max-width: 768px) {
      font-size: 22px;
    }
  }

  p {
    margin: 20px 0;

    @media only screen and (max-width: 1024px) {
      font-size: 16px;
    }

    @media only screen and (max-width: 768px) {
      font-size: 14px;
    }
  }
`;

const Right = styled.div`
  width: 50%;

  @media only screen and (max-width: 1024px) {
    width: 100%;
    padding: 30px 0;
  }
`;

const Box = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  text-align: left;

  .icon_contact{
   font-size: 25px;
   color: var(--secondary-color);
   margin-right: 17px;
   
  }
  
`;

export default ContactBody;
